import type { ReactNode } from 'react';
import type { PropertyFileTreeNode } from '@/shared/api';
import { AkteContentFolderRow } from './AkteContentFolderRow';
import type { useAkteDragMove } from './useAkteDragMove';

interface Props {
  folders: PropertyFileTreeNode[];
  onNavigate: (path: string) => void;
  folderMenu?: (node: PropertyFileTreeNode) => ReactNode;
  dropProps: ReturnType<typeof useAkteDragMove>['dropProps'];
}

/** Die Unterordner-Zeilen einer Content-Zone — in Liste und Kachelansicht identisch. */
export function AkteFolderRows({ folders, onNavigate, folderMenu, dropProps }: Props) {
  return folders.map((f) => {
    // Spring-Loading: beim Ziehen über einen Unterordner hineinnavigieren (Content-Pendant zum
    // Aufklappen in der Sidebar).
    const drop = dropProps(f.path, () => onNavigate(f.path));
    return (
      <AkteContentFolderRow
        key={f.path}
        node={f}
        onNavigate={onNavigate}
        menu={folderMenu?.(f)}
        dropProps={drop.props}
        dropActive={drop.active}
      />
    );
  });
}
